import styled from "@emotion/styled";

export const StyledFooter = styled.footer`
  background: black;
  padding: 74px 0;

  ${props => props.theme.breakpoints.down("md")} {
    margin-top: 128px;
  }
`;